import { useState, useEffect } from 'react';

interface MobileDetectionState {
  isMobile: boolean;
  isLoading: boolean;
}

/**
 * Hook to detect if the user is on a mobile device
 * Uses both user agent detection and viewport width for comprehensive detection
 */
export function useMobileDetection(): MobileDetectionState {
  const [state, setState] = useState<MobileDetectionState>({
    isMobile: false,
    isLoading: true,
  });

  useEffect(() => {
    const detectMobile = () => {
      // User agent detection for mobile devices
      const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobileUserAgent = mobileRegex.test(userAgent);

      // Viewport width detection (mobile breakpoint: 768px)
      const isMobileViewport = typeof window !== 'undefined' ? window.innerWidth < 480 : false;

      // Device is considered mobile if either condition is true
      const isMobile = isMobileUserAgent || isMobileViewport;

      setState({
        isMobile,
        isLoading: false,
      });
    };

    // Initial detection
    detectMobile();

    // Listen for resize events to handle viewport changes
    const handleResize = () => {
      detectMobile();
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return state;
} 